import axios from "axios";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Footer from "../../../../Components/Footer";
import ReactApexChart from "react-apexcharts";
import Select from "react-select";
import LoadingScreen from "../../../../Components/LoadingScreen";
import Loading2 from "../../../../Components/Loading2";

const AnalyticsBasedOnStockMovement = () => {
  const [fromdate, setFromdate] = useState(
    new Date(new Date().getFullYear(), 0, 2).toISOString()
  );
  const [todate, setTodate] = useState(new Date().toISOString());
  const [data, setData] = useState([]);
  const [datawithitem, setDatawithitem] = useState([]);
  const [datawithtranstype, setDataWithTransType] = useState([]);
  const [datawithitemtranstype, setDataWithItemTransType] = useState([]);
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  var [selItemCode, setSelItemCode] = useState("");
  var [selItemName, setSelItemName] = useState("");
  const [product, setProduct] = useState([]);
  const [isloading, setisloading] = useState(true);
  const [isLoading2, setLoading2] = useState(true);
  const [transtype, setTranstype] = useState([]);
  var [seltranstype, setSeltranstype] = useState("");

  useEffect(() => {
    AnalyzeBasedOnStockMovements();
    getProduct();
    getTransType();
    setisloading(false);
  }, [selItemCode, selItemName, seltranstype, fromdate, todate]);

  const getProduct = () => {
    axios
      .get(`${BASEURL}/Item`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setProduct(response.data);
      })
      .catch((error) => {
        console.error("Error fetching itemcode:", error);
      });
  };

  const getTransType = () => {
    axios
      .get(`${BASEURL}/TransactionType`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setTranstype(response.data);
      })
      .catch((error) => {
        console.error("Error fetching TransType:", error);
      });
  };

  const handleItemName = (e) => {
    const selectedValue = e;
    const selectedOption = product.find(
      (obj) => obj.OM_ITEM_DESCRIPTION === selectedValue
    );
    if (selectedValue === "") {
      setSelItemName("");
      setSelItemCode("");
      setDatawithitem([]);
      setDataWithItemTransType([]);
    } else if (selectedOption === "") {
      setSelItemCode("");
      setSelItemName("");
      setDatawithitem([]);
      setDataWithItemTransType([]);
    } else {
      setSelItemName(selectedValue);
      setSelItemCode(selectedOption.OM_ITEM_CODE);
    }
  };

  const handleItemCode = (e) => {
    const selectedValue = e;
    const selectedOption = product.find(
      (obj) => obj.OM_ITEM_CODE === selectedValue
    );
    if (selectedValue === "") {
      setSelItemName("");
      setSelItemCode("");
      setDatawithitem([]);
      setDataWithItemTransType([]);
    } else if (selectedOption === "") {
      setSelItemName("");
      setSelItemCode("");
      setDatawithitem([]);
      setDataWithItemTransType([]);
    } else {
      setSelItemCode(selectedValue);
      setSelItemName(selectedOption.OM_ITEM_DESCRIPTION);
    }
  };

  const AnalyzeBasedOnStockMovements = () => {
    if (selItemCode === "" && seltranstype === "") {
      selItemCode = "null";
      seltranstype = "null";
      setLoading2(true);
      axios
        .post(
          `${BASEURL}/AnalyticsBasedOnStockMovement/${selItemCode}/${seltranstype}`,
          {
            Fromdate: moment(fromdate).format("DD/MM/YYYY"),
            Todate: moment(todate).format("DD/MM/YYYY"),
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        )
        .then((response) => {
          setLoading2(false);
          setData(response.data);
          console.log(response.data);
        })
        .catch((error) => {
          setLoading2(false);
          console.log(error);
        });
    } else if (selItemCode !== "" && seltranstype === "") {
      seltranstype = "null";
      setLoading2(true);
      axios
        .post(
          `${BASEURL}/AnalyticsBasedOnStockMovement/${selItemCode}/${seltranstype}`,
          {
            Fromdate: moment(fromdate).format("DD/MM/YYYY"),
            Todate: moment(todate).format("DD/MM/YYYY"),
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        )
        .then((response) => {
          setLoading2(false);
          setDatawithitem(response.data);
          console.log(response.data);
        })
        .catch((error) => {
          setLoading2(false);
          console.log(error);
        });
    } else if (selItemCode === "" && seltranstype !== "") {
      selItemCode = "null";
      setLoading2(true);
      axios
        .post(
          `${BASEURL}/AnalyticsBasedOnStockMovement/${selItemCode}/${seltranstype}`,
          {
            Fromdate: moment(fromdate).format("DD/MM/YYYY"),
            Todate: moment(todate).format("DD/MM/YYYY"),
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        )
        .then((response) => {
          setLoading2(false);
          setDataWithTransType(response.data);
          console.log(response.data);
        })
        .catch((error) => {
          setLoading2(false);
          console.log(error);
        });
    } else if (selItemCode !== "" && seltranstype !== "") {
      setLoading2(true);
      axios
        .post(
          `${BASEURL}/AnalyticsBasedOnStockMovement/${selItemCode}/${seltranstype}`,
          {
            Fromdate: moment(fromdate).format("DD/MM/YYYY"),
            Todate: moment(todate).format("DD/MM/YYYY"),
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        )
        .then((response) => {
          setLoading2(false);
          setDataWithItemTransType(response.data);
          console.log(response.data);
        })
        .catch((error) => {
          setLoading2(false);
          console.log(error);
        });
    }
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div>
      <div
        className="Unapp_payment"
        style={{
          display: "flex",
          justifyContent: "space-between",
          position: "sticky",
          top: "0",
          left: "0",
          zIndex: "500",
        }}
      >
        <h1 style={{ textAlign: "center" }} className="Titles">
          Tech23 Dashboards
        </h1>
        <div className="nav_1">
          <div className="back_btn">
            {" "}
            <Link
              style={{ textDecoration: "none", color: "white" }}
              to={"/StockDashboard"}
            >
              <button className="View">Back</button>
            </Link>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="h2">
        <h1>Analytics based on Stock Movement</h1>
      </div>
      <div className="align__date">
        <div className="">
          <div>
            <p>From Date :</p>
          </div>
          <div>
            <input
              className="as_at"
              value={fromdate.split("T")[0]}
              type="date"
              onChange={(e) => {
                if (e.target.value === "") {
                  alert("Please select a valid fromdate");
                } else {
                  setFromdate(e.target.value);
                }
              }}
            />
          </div>

          <div>
            <p>To Date :</p>
          </div>
          <div>
            <input
              className="as_at"
              value={todate.split("T")[0]}
              type="date"
              onChange={(e) => {
                if (e.target.value === "") {
                  alert("Please select a valid todate");
                } else {
                  setTodate(e.target.value);
                }
              }}
            />
          </div>
        </div>
        <div className="Product_analytics_item">
          <div className="analytics_product_select">
            <aside>
              <p>Item Code :</p>
            </aside>
            <Select
              className="Select_item_code"
              onChange={(selectedOption) => {
                if (data.length <= 0) {
                  alert("There is no data to sort!");
                } else {
                  handleItemCode(selectedOption.value);
                }
              }}
              value={
                selItemCode
                  ? { label: selItemCode, value: selItemCode }
                  : { label: "", value: "" }
              }
              options={[
                { value: "", label: "" },
                ...product.map((item) => ({
                  value: item.OM_ITEM_CODE,
                  label: item.OM_ITEM_CODE,
                })),
              ]}
            />
          </div>
          <div className="analytics_product_select">
            <aside>
              <p>Item Name :</p>
            </aside>
            <Select
              className="Select_item_name"
              onChange={(selectedOption) => {
                if (data.length <= 0) {
                  alert("There is no data to sort!");
                } else {
                  handleItemName(selectedOption.value);
                }
              }}
              value={
                selItemName
                  ? { label: selItemName, value: selItemName }
                  : { label: "", value: "" }
              }
              options={[
                { value: "", label: "" },
                ...product.map((item) => ({
                  value: item.OM_ITEM_DESCRIPTION,
                  label: item.OM_ITEM_DESCRIPTION,
                })),
              ]}
            />
          </div>
        </div>
      </div>
      <main>
        <div className="Supp_analytics_Supp_Name">
          <div style={{ marginLeft: "12px", fontWeight: "600" }}>
            <aside className="lbl_sub_category">
              <p>Transaction Type :</p>
            </aside>
          </div>
          <div>
            <Select
              className="Select_Category"
              onChange={(e) => {
                if (data.length <= 0) {
                  alert("There is no data to sort!");
                } else {
                  setSeltranstype(e.value);
                  if (e.value === "") {
                    setDataWithItemTransType([]);
                    setDataWithTransType([]);
                  }
                }
              }}
              value={
                seltranstype
                  ? { label: seltranstype, value: seltranstype }
                  : { label: "", value: "" }
              }
              options={[
                { value: "", label: "" },
                ...transtype.map((item) => ({
                  value: item.TRANSTYPE,
                  label: item.TRANSTYPE,
                })),
              ]}
            />
          </div>
        </div>
      </main>
      <div style={{ width: "90%", margin: "0 auto", marginTop: "15px" }}>
        {isLoading2 ? (
          <Loading2 />
        ) : (
          <>
            {" "}
            {selItemCode && !seltranstype && datawithitem.length > 0 ? (
              <ReactApexChart
                options={{
                  chart: {
                    id: "line-chart", // Change the ID for the line chart
                  },
                  xaxis: {
                    categories: datawithitem.map((item) =>
                      moment(item.MONTHNAME).format("MMM-YYYY")
                    ),
                    title: {
                      text: "Months", // X-axis label
                    },
                  },
                  yaxis: {
                    title: {
                      text: "Quantity", // Y-axis label
                    },
                  },
                  dataLabels: {
                    enabled: false, // Disable the data labels for line chart
                  },
                }}
                series={[
                  {
                    name: "Quantity",
                    data: datawithitem.map((item) => item.QTY),
                  },
                ]}
                type="line" // Change chart type to "line"
                height={300}
              />
            ) : !selItemCode && seltranstype && datawithtranstype.length > 0 ? (
              <ReactApexChart
                options={{
                  chart: {
                    id: "line-chart", // Change the ID for the line chart
                  },
                  xaxis: {
                    categories: datawithtranstype.map((item) =>
                      moment(item.MONTHNAME).format("MMM-YYYY")
                    ),
                    title: {
                      text: "Item Name", // X-axis label
                    },
                  },
                  yaxis: {
                    title: {
                      text: "Quantity", // Y-axis label
                    },
                  },
                  dataLabels: {
                    enabled: false, // Disable the data labels for line chart
                  },
                }}
                series={[
                  {
                    name: "Quantity",
                    data: datawithtranstype.map((item) => item.QTY),
                  },
                ]}
                type="line" // Change chart type to "line"
                height={300}
              />
            ) : selItemCode &&
              seltranstype &&
              datawithitemtranstype.length > 0 ? (
              <ReactApexChart
                options={{
                  chart: {
                    id: "line-chart", // Change the ID for the line chart
                  },
                  xaxis: {
                    categories: datawithitemtranstype.map((item) =>
                      moment(item.MONTHNAME).format("MMM-YYYY")
                    ),
                    title: {
                      text: "Item Name", // X-axis label
                    },
                  },
                  yaxis: {
                    title: {
                      text: "Quantity", // Y-axis label
                    },
                  },
                  dataLabels: {
                    enabled: false, // Disable the data labels for line chart
                  },
                }}
                series={[
                  {
                    name: "Quantity",
                    data: datawithitemtranstype.map((item) => item.QTY),
                  },
                ]}
                type="line" // Change chart type to "line"
                height={300}
              />
            ) : !selItemCode && !seltranstype && data.length > 0 ? (
              <ReactApexChart
                options={{
                  chart: {
                    id: "line-chart", // Change the ID for the line chart
                  },
                  xaxis: {
                    categories: data.map((item) => item["ITEM DESCRIPTION"]),
                    title: {
                      text: "Item Name", // X-axis label
                    },
                  },
                  yaxis: {
                    title: {
                      text: "Quantity", // Y-axis label
                    },
                  },
                  dataLabels: {
                    enabled: false, // Disable the data labels for line chart
                  },
                }}
                series={[
                  {
                    name: "Quantity",
                    data: data.map((item) => item.QTY),
                  },
                ]}
                type="line" // Change chart type to "line"
                height={300}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "20px",
                  marginTop: "50px",
                  textDecoration: "underline",
                }}
              >
                NO RESULTS FOUND
              </div>
            )}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AnalyticsBasedOnStockMovement;
